import React, { useLayoutEffect } from 'react';
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  breadcrumbsPropTypes,
  matchPropTypes,
} from '../../../common/resource/proptypes/CommonPropTypes';
import { GENERAL_INCOME_TYPE_PATH } from '../../../../config/paths';
import { clearGeneralIncomeType, getGeneralIncomeType } from '../../../../actions';
import Loader from '../../../common/Loader';
import Content from '../../../layout/Content';
import GeneralIncomeTypeToolbar from './GeneralIncomeTypeToolbar';
import NoDataResource from '../../../common/resource/NoDataResource';
import GeneralIncomeTypeBasicInformationResource from './resource/GeneralIncomeTypeBasicInformationResource';
import InternalResource from '../../../common/resource/InternalResource';

export const GeneralIncomeType = ({
  breadcrumbs,
  match: {
    params: { id: generalIncomeTypeId },
  },
  generalIncomeType,
  loading,
  dispatchGetGeneralIncomeType,
  dispatchClearGeneralIncomeType,
}) => {
  useLayoutEffect(() => {
    dispatchGetGeneralIncomeType({ generalIncomeTypeId });

    return () => dispatchClearGeneralIncomeType();
  }, []);

  let content = null;
  let toolbar = null;
  if (loading) content = <Loader />;
  else if (generalIncomeType.isEmpty()) {
    content = <NoDataResource returnPage={GENERAL_INCOME_TYPE_PATH} />;
  } else {
    const generalIncomeTypeJSON = generalIncomeType.toJS();
    content = (
            <>
              <h3>Información Básica</h3>
              <GeneralIncomeTypeBasicInformationResource {...generalIncomeTypeJSON} />
              <InternalResource id={generalIncomeTypeJSON.id}
                        createDate={generalIncomeTypeJSON.createDate}
                        lastUpdate={generalIncomeTypeJSON.lastUpdate}/>
            </>
      
  );
    toolbar = <GeneralIncomeTypeToolbar generalIncomeTypeId={generalIncomeTypeJSON.id} />;
  }

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Tipo de Ingreso"
      toolbar={toolbar}
      content={content}
    />
  );
};

GeneralIncomeType.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  generalIncomeType: PropTypes.instanceOf(Immutable.Map).isRequired,
  loading: PropTypes.bool,
  match: matchPropTypes.isRequired,
  dispatchGetGeneralIncomeType: PropTypes.func.isRequired,
  dispatchClearGeneralIncomeType: PropTypes.func.isRequired,
};

GeneralIncomeType.defaultProps = {
  loading: false,
};

const mapStateToProps = ({ AccountingUnit }) => ({
  breadcrumbs: [
    ...AccountingUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Tipos de Ingreso',
      href: GENERAL_INCOME_TYPE_PATH,
    },
    {
      text: 'Ver',
      href: '',
    },
  ],
  generalIncomeType: AccountingUnit.GeneralIncomeType.getIn(['current', 'content']),
  loading: !AccountingUnit.GeneralIncomeType.getIn(['current', 'activity']).isEmpty(),
});

const mapDispatchToProps = {
  dispatchGetGeneralIncomeType: getGeneralIncomeType,
  dispatchClearGeneralIncomeType: clearGeneralIncomeType,
};

export default connect(mapStateToProps, mapDispatchToProps)(GeneralIncomeType);
